import type { QueryKey } from '@tanstack/react-query';

import {
    useProviderAccountsController_getAccounts,
    useProviderAccountsController_getClientIntegrations,
    useProviderConfigController_getLocationConfig,
} from '@/services/hooks';

/** The generated hook's own key, so an invalidation reaches every observer of the site. */
export function providerConfigQueryKey(locationId: number): QueryKey {
    return useProviderConfigController_getLocationConfig.info(locationId).key;
}

export function providerAccountsQueryKey(): QueryKey {
    return useProviderAccountsController_getAccounts.info().key;
}

export function clientIntegrationsQueryKey(clientId: number): QueryKey {
    return useProviderAccountsController_getClientIntegrations.info(clientId).key;
}
